import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { authService } from "../../../../services";
import FanLiveEventPublicPage from "../FanLiveEventPublicPage";
import FanLiveEventTicketPage from "../FanLiveEventTicketPage";

function FanLiveEventWrapper() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // TODO: check this code after fight event
  useEffect(() => {
    const creatorCode = searchParams.get("code");
    if (creatorCode && localStorage.getItem("creatorCode") !== creatorCode) {
      localStorage.setItem("creatorCode", creatorCode);
    }
  }, []);

  if (authService.isAuthenticated()) {
    return <FanLiveEventTicketPage />;
  } else {
    return <FanLiveEventPublicPage />;
  }
}

export default FanLiveEventWrapper;
